import React from "react";
import { useDataProvider } from "react-admin";

export const useOrderStatuses = () => {
	const dataProvider = useDataProvider();
	const [orderStatuses, setOrderStatuses] = React.useState({});

	React.useEffect(() => {
		dataProvider
			.getList("order-statuses", {
				pagination: { page: 1, perPage: 1000 },
				sort: { field: "id", order: "ASC" },
				filter: {},
			})
			.then(({ data }) => {
				const statusesMap = {};
				data.forEach((status) => {
					statusesMap[status.id] = status;
				});
				setOrderStatuses(statusesMap);
			})
			.catch(() => {
				setOrderStatuses({});
			});
	}, [dataProvider]);

	return orderStatuses;
};
